import { createSignal, createEffect } from "solid-js";

const PREFIX = "vektor.table.";

function read<T>(key: string, fallback: T): T {
  if (typeof localStorage === "undefined") return fallback;
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (raw == null) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

function write<T>(key: string, value: T) {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    /* ignore quota / unavailable */
  }
}

export function useTablePref<T>(key: string, initial: T): [() => T, (next: T | ((prev: T) => T)) => void] {
  const [value, setValueRaw] = createSignal<T>(read(key, initial));

  createEffect(() => {
    write(key, value());
  });

  const setValue = (next: T | ((prev: T) => T)) => {
    setValueRaw((prev) => {
      const resolved = typeof next === "function" ? (next as (p: T) => T)(prev) : next;
      return resolved as Exclude<T, Function>;
    });
  };

  return [value, setValue];
}
